import Link from 'next/link'
import { useLocale, useTranslations } from 'next-intl'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb'
import { CategoryType } from '@/types/category'
import useMetaStore from '../../../store/meta'
import { getLocalizedValue } from '@/lib/utils'

type PropsType = {
  category: CategoryType
}

const Path = ({ category }: PropsType) => {
  const t = useTranslations()
  const locale = useLocale()
  const { metaState } = useMetaStore()
  const defaultLocale = metaState.response?.generalSettings.adminDefaultLocale

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {category.parents && category.parents.length > 0
          ? category.parents.flatMap(parent => {
              const parentName =
                parent.translations[locale]?.name ||
                (defaultLocale && parent.translations[defaultLocale]?.name) ||
                Object.values(parent.translations)[0]?.name ||
                t('unknown')

              const elements = [
                <BreadcrumbItem key={`item-${parent.id}`}>
                  <BreadcrumbLink asChild>
                    <Link href={`/products/categories/${parent.id}`}>{parentName}</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
              ]

              elements.push(<BreadcrumbSeparator key={`separator-${parent.id}`} />)

              return elements
            })
          : null}

        <BreadcrumbItem key={`item-${category.id}`}>
          <Link href={`/products/categories/${category.id}`}>
            {getLocalizedValue(category, 'name', locale, defaultLocale)}
          </Link>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}

export default Path
